"use client";
import { jsxs as x, Fragment as k, jsx as m } from "react/jsx-runtime";
import { useState as A, useRef as ie, createElement as le } from "react";
import { LAYERS as se } from "../../common/constants/layers.js";
import { isDefined as re } from "../../common/helpers/isDefined.js";
import ae from "../../common/styles/components/InputWrapper.js";
import ce from "../icon/Icon.js";
import de from "../portal/Portal.js";
import ge from "./SelectList.js";
import ue from "../spacer/Spacer.js";
import pe from "../tag/Tag.js";
import fe from "../visually-hidden/VisuallyHidden.js";
import { css as O } from "@emotion/react";
import v from "@emotion/styled";
import { COLORS as M } from "../../tokens/colors/Colors.js";
import { SPACINGS as C } from "../../tokens/spacings/Spacings.js";
import { useMultipleSelection as he, useSelect as r } from "downshift";
import { usePopper as me } from "react-popper";
const Se = (t) => {
  const {
    "aria-errormessage": c,
    "aria-invalid": l,
    className: n,
    defaultValue: o,
    disabled: a,
    feItems: y,
    feLayer: K,
    feListHeight: L,
    fePlaceholder: b,
    feSeverity: N,
    feSize: E,
    id: B,
    multiple: d,
    onChange: T,
    value: I
  } = t, W = d ? t.feMultiSelectionText ?? "$1 selection/selections made" : void 0, R = d ? t.feHideSelectionTags ?? !1 : void 0, j = d ? t.feSelectionTagsText ?? "Selections" : void 0, g = y.flatMap((e) => e.items ?? e), D = {
    onSelectedItemsChange: ({ selectedItems: e }) => {
      d && T && e !== void 0 && T(e.map((s) => s.value).filter(re));
    }
  };
  d && (o !== void 0 && (D.initialSelectedItems = g.filter(
    (e) => e.value !== void 0 && o.includes(e.value)
  )), I !== void 0 && (D.selectedItems = g.filter(
    (e) => e.value !== void 0 && I.includes(e.value)
  )));
  const {
    addSelectedItem: z,
    getDropdownProps: F,
    removeSelectedItem: U,
    getSelectedItemProps: V,
    selectedItems: u,
    setSelectedItems: G
  } = he(D), h = {
    items: g,
    isItemDisabled: (e) => e.disabled === !0,
    itemToString: (e) => String(e == null ? void 0 : e.label)
  };
  d ? (h.onSelectedItemChange = ({ selectedItem: e }) => {
    e && (u.find((s) => s.value === e.value) ? G(u.filter((s) => s.value !== e.value)) : z(e));
  }, h.selectedItem = null, h.stateReducer = (e, s) => {
    const { changes: i, type: p } = s, { selectedItem: f } = i, $ = H(e, p, g);
    switch (p) {
      case r.stateChangeTypes.ToggleButtonKeyDownCharacter:
        return {
          ...i,
          selectedItem: f != null && f.disabled ? void 0 : f
        };
      case r.stateChangeTypes.ToggleButtonKeyDownArrowUp:
      case r.stateChangeTypes.ToggleButtonKeyDownArrowDown:
        return {
          ...i,
          highlightedIndex: $
        };
      case r.stateChangeTypes.ToggleButtonKeyDownEnter:
      case r.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
      case r.stateChangeTypes.ToggleButtonClick:
      case r.stateChangeTypes.ItemClick:
        return {
          ...i,
          isOpen: !0,
          // Keep the menu open after clicking item.
          highlightedIndex: e.highlightedIndex
          // Keep the recently clicked item highlighted.
        };
    }
    return i;
  }) : (h.onSelectedItemChange = ({ selectedItem: e }) => {
    T && (e == null ? void 0 : e.value) !== void 0 && T(e.value);
  }, h.stateReducer = (e, s) => {
    const { changes: i, type: p } = s, { selectedItem: f } = i, $ = H(e, p, g);
    switch (p) {
      case r.stateChangeTypes.ToggleButtonKeyDownCharacter:
        return {
          ...i,
          selectedItem: f != null && f.disabled ? void 0 : f
        };
      case r.stateChangeTypes.ToggleButtonKeyDownArrowDown:
      case r.stateChangeTypes.ToggleButtonKeyDownArrowUp:
        return {
          ...i,
          highlightedIndex: $
        };
    }
    return i;
  }, o !== void 0 && (h.initialSelectedItem = g.find((e) => e.value === o)), I !== void 0 && (h.selectedItem = g.find((e) => e.value === I) ?? null));
  const {
    isOpen: P,
    selectedItem: S,
    getToggleButtonProps: Y,
    getMenuProps: q,
    highlightedIndex: J,
    getItemProps: Q
  } = r(h), [w, X] = A(null), [Z, _] = A(null), ee = ie(null), { styles: te, attributes: ne } = me(w, Z, {
    strategy: "fixed",
    placement: "bottom-start",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 0]
        }
      }
    ]
  }), oe = w == null ? void 0 : w.getBoundingClientRect().width;
  return /* @__PURE__ */ x(k, { children: [
    /* @__PURE__ */ m(
      Te,
      {
        className: n,
        feSeverity: N,
        feSize: E,
        ref: X,
        children: /* @__PURE__ */ x(
          Ie,
          {
            "aria-errormessage": c,
            "aria-invalid": l,
            stIsOpen: P,
            type: "button",
            ...F(
              Y({
                disabled: a,
                "aria-labelledby": B ? `${B}-label` : void 0,
                id: B,
                onClick: () => window.dispatchEvent(new Event("resize"))
              })
            ),
            children: [
              /* @__PURE__ */ m(we, { children: d ? u.length === 0 && b ? b : R && u.length === 1 ? u[0].label : ve(W, u.length) : (S == null ? void 0 : S.label) ?? b ?? /* @__PURE__ */ m(ue, {}) }),
              /* @__PURE__ */ m(ce, { feIcon: "chevronDown" })
            ]
          }
        )
      }
    ),
    d && !R && u.length > 0 && // TODO: Do we need feSelectionTagsText when using new popover API
    /* @__PURE__ */ m(xe, { ref: ee, children: /* @__PURE__ */ x(k, { children: [
      /* @__PURE__ */ x(fe, { children: [
        j,
        ": "
      ] }),
      u.map((e, s) => {
        var i;
        return /* @__PURE__ */ le(
          pe,
          {
            ...V({ selectedItem: e, index: s }),
            feClosable: {
              onClick: (p) => {
                p.stopPropagation(), U(e);
              }
            },
            key: s
          },
          ((i = g.find((p) => p.value === e.value)) == null ? void 0 : i.label) ?? ""
        );
      })
    ] }) }),
    /* @__PURE__ */ m(de, { "data-portals": "select", children: /* @__PURE__ */ m(
      Ce,
      {
        ...ne.popper,
        feLayer: K,
        stIsOpen: P,
        ref: _,
        style: te.popper,
        children: /* @__PURE__ */ m(
          ge,
          {
            allItems: g,
            getItemProps: Q,
            getMenuProps: q,
            highlightedIndex: J,
            isOpen: P,
            items: y,
            listHeight: L,
            listWidth: oe,
            selectedItems: d ? u : S ? [S] : void 0,
            size: E
          }
        )
      }
    ) })
  ] });
};
Se.displayName = "SelectField";
const ve = (t, c) => {
  const l = (t == null ? void 0 : t.split(" ")) ?? [];
  return l.forEach((n, o) => {
    if (n.includes("/")) {
      const a = n.split("/");
      c === 1 ? l[o] = a[0] : l[o] = a[1];
    }
    n.includes("$1") && (l[o] = n.replace("$1", `${c}`));
  }), l.join(" ");
};
function H(t, c, l) {
  const n = t.highlightedIndex ?? -1, o = c === r.stateChangeTypes.ToggleButtonKeyDownArrowUp ? -1 : 1;
  return ye(l, n, o);
}
function ye(t, c, l) {
  let n = c + l;
  for (n = o(n); t[n].disabled; )
    n += l, n = o(n);
  return n;
  function o(a) {
    const y = a >= t.length;
    return a < 0 ? a = 0 : y ? a = t.length - 1 : a;
  }
}
const Te = v(ae)`
	padding: 0;
`, Ie = v.button(
  ({ stIsOpen: t }) => O`
		align-items: center;
		color: ${M.black};
		cursor: pointer;
		display: flex;
		gap: ${C.sm};
		height: inherit;
		justify-content: space-between;
		padding-inline: ${C.sm};
		text-align: left;
		width: 100%;

		&:not(:disabled):hover {
			background-color: ${!t && M.primary200};
		}
	`
), we = v.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`, xe = v.div`
	align-items: center;
	display: flex;
	gap: ${C.xs};
	margin-block-start: ${C.sm};
`, Ce = v.div(
  ({ stIsOpen: t, feLayer: c }) => O`
		pointer-events: ${t ? "initial" : "none"};
		z-index: ${c ?? se.select};
	`
);
export {
  Se as default
};
